import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { transformDivisionsResponse } from "~pages/Divisions/DivisionListPage/utilities/transforms.ts";
import type { DivisionResponse } from "~types/division.ts";
import { removeEmptyFields } from "~utils/removeEmptyFields.ts";

type Props = {
  customParams: Record<string, string>;
  enabled?: boolean;
};

export const useFetchDivisionList = ({ customParams, enabled = true }: Props) => {
  const request = useApi();
  const { organizationId, sport, conferenceId } = useParams();

  const params = new URLSearchParams(removeEmptyFields(customParams) as Record<string, string>);

  return useQuery({
    queryKey: ["divisions", sport, organizationId, conferenceId, customParams],
    enabled,
    queryFn: () =>
      request<DivisionResponse>(`${sport}/o/${organizationId}/conferences/${conferenceId}/divisions?${params.toString()}`).then(
        (response) => transformDivisionsResponse(response, conferenceId),
      ),
  });
};
